import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type PrimaryButtonProps = {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
};
export function PrimaryButton({
  children,
  onClick,
  className = ''
}: PrimaryButtonProps) {
  const handlePurchase = () => {
    onClick();
    window.location.assign('https://peacefulparentingkit.gumroad.com/l/ppinrq?wanted=true');
  };
  return <button type="button" onClick={handlePurchase} className={`inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#a84b35] px-6 py-4 text-center text-sm font-bold tracking-wide text-white shadow-[0_7px_0_#713021] transition hover:bg-[#923d2a] focus:outline-none focus:ring-4 focus:ring-[#a84b35]/25 active:translate-y-1 active:shadow-[0_3px_0_#713021] sm:w-auto ${className}`} data-id="element-151">
      {children}
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2.5} data-id="element-152" />
    </button>;
}